import { Button, Container, Link, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MenuIcon from "@material-ui/icons/Menu";
import M24SwitchModeButton from "components/section-m-24/M24SwitchModeButton";
import React from "react";

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  appBar: {
    marginBottom: 0,
    backgroundColor: theme.palette.background.main,
  },
  wrapToolbar: {
    paddingLeft: 0,
  },
  toolbarTop: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.main,
  },
  toolbar: {
    justifyContent: "space-between",
  },
  menuContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
  menuItem: {
    marginLeft: 12,
  },
  search: {
    display: "flex",
    flexDirection: "row",
    height: 55,
    backgroundColor: "#ffffff",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    // backgroundColor: fade(theme.palette.common.white, 0.15),
    // "&:hover": {
    //   backgroundColor: fade(theme.palette.common.white, 0.25),
    // },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    // position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#c7ccdf",
  },
  inputRoot: {
    // color: "#5f5f5f",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "20ch",
      "&:focus": {
        width: "30ch",
      },
    },
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  textTitle: {
    color: "#868686",
    marginLeft: theme.spacing(2),
  },
}));

export default function Header({
  hideMenubar = false,
  title,
  onClickLogo = () => {},
  onClickHamberger = () => {},
}) {
  const classes = useStyles();
  const theme = useTheme();
  const isMD = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <AppBar
      elevation={0}
      position="static"
      color="secondary"
      className={classes.appBar}
    >
      <Toolbar id="toolbarTop" className={classes.toolbarTop}>
        <Hidden lgUp implementation="css">
          <IconButton
            color="secondary"
            aria-label="menu"
            onClick={onClickHamberger}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
      <Container className={classes.wrapToolbar}>
        <Toolbar id="back-to-top-anchor" className={classes.toolbar}>
          <Link onClick={onClickLogo} className={classes.flexRow}>
            <img
              src={"/assets/images/logo.png"}
              alt="smart-visa-logo"
              style={{
                width: 172,
                height: 52,
                cursor: "pointer",
              }}
            />
            {title && (
              <Typography variant="h4" className={classes.textTitle}>
                {title}
              </Typography>
            )}
          </Link>
          {!hideMenubar && (
            <nav>
              <ul className={classes.menuContainer}>
                <Link href="/">
                  <Button
                    // color="secondary"
                    component="li"
                    className={classes.menuItem}
                  >
                    Home
                  </Button>
                </Link>
                <div className={classes.search}>
                  <M24SwitchModeButton />
                </div>
              </ul>
            </nav>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
